
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 240.31 307.35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M168.34 0v71.96h71.97L168.34 0z"}}),_c('path',{staticClass:"a",attrs:{"d":"M163.61 76.69V0H14.15A14.14 14.14 0 000 14.15v279a14.14 14.14 0 0014.15 14.15h212a14.15 14.15 0 0014.12-14.11V76.69zm-78.09 67.6c-.3-24.48 4.32-46.23 37.21-46.23s37.51 21.75 37.21 46.23c.77.09 2.65 1.85 2.62 2.77a87.31 87.31 0 01-2.45 18.29 4 4 0 01-3.15 2.45 87.58 87.58 0 01-10.94 20.65c-4.7 6.45-9.25 11.1-14.83 13.19-3.88 1.45-13 1.45-16.92 0-5.58-2.09-10.13-6.74-14.83-13.19A88 88 0 0188.5 167.8a4 4 0 01-3.15-2.45 87.31 87.31 0 01-2.45-18.29c-.03-.92 1.85-2.68 2.62-2.77zM34.27 251.87c0-10 1.9-19.5 8.55-27.92 17.87-22.63 35.88-14.8 51.88-27.24 4.52 6 9.87 11.54 17 14.22 5.55 2.08 16.45 2.08 22 0 7.26-2.72 12.66-8.38 17.21-14.45 15.06 11.61 34.21 5.3 51.72 27.47 6.64 8.42 7.64 16.92 7.64 27.92z"}})])
          )
        }
      }
    